import apiService from '@udacity/ureact-api-service';

type UserPreferences = {
  meta: {
    count: number;
    pagination: {
      limit: number;
      offset: number;
      next_url: string;
      prev_url: string;
    };
  };
  objects: {
    created_at: string;
    name: string;
    type: string;
    updated_at: string | null;
    user_id: string;
    value: string;
  }[];
};

export const getUserPreferences = async () => {
  const userPreferenceData: UserPreferences = await apiService.makeGetRequest('/api/user', '/me/preferences');

  const preferredLanguage = userPreferenceData.objects.find((obj) => obj.name === 'preferred_language')?.value;

  return { preferredLanguage };
};
